import React from 'react';
import { compose, graphql, withApollo } from 'react-apollo';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Group from '@material-ui/icons/Group';
import Card from 'components/Card/Card.jsx';
import CardBody from 'components/Card/CardBody.jsx';
import CardHeader from 'components/Card/CardHeader.jsx';
import CardIcon from 'components/Card/CardIcon.jsx';
import CategoryTable from './CategoryTable';
import {
  getAllCategories,
  updateCategoryPosition,
} from '../schema/shop-schema.graphql';
import localization from '../../../i18n/localization';
import { withSnackbar } from '../../snackbar/SnackbarContext';

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
  },
});

class Categories extends React.Component {
  state = {
    page: 0,
    rowsPerPage: 50,
    categories: [],
  };

  getCategories = async () => {
    const { client } = this.props;

    const { data } = await client.query({
      query: getAllCategories,
    });

    this.setState(prevState => ({
      ...prevState,
      categories: data.categories,
    }));
  };

  onPositionChange = async (category, direction) => {
    const { updateCategoryPosition, addNotification } = this.props;

    const { data } = await updateCategoryPosition({
      variables: {
        categoryUpdatePosition: {
          id: category.id,
          direction: direction,
        },
      },
    });

    this.setState(prevState => ({
      ...prevState,
      categories: data.categories,
    }));
    addNotification('success', localization.de.shop.OPERATION_SUCCESS);
  };

  componentDidMount() {
    this.getCategories();
  }

  render() {
    const { classes, history } = this.props;
    const { categories } = this.state;

    return (
      <div className={classes.root}>
        <Card>
          <CardHeader icon stats>
            <CardIcon color="rose">
              <Group />
            </CardIcon>
          </CardHeader>
          <CardBody>
            <CategoryTable
              categories={categories.map(category => {
                return {
                  ...category,
                  title: category.title,
                  type: category.type,
                };
              })}
              onClick={id => history.push(`/shop/category/${id}`)}
              onPositionChange={(category, direction) =>
                this.onPositionChange(category, direction)
              }
            />
          </CardBody>
        </Card>
      </div>
    );
  }
}

Categories.propTypes = {
  classes: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

const enhance = compose(
  graphql(updateCategoryPosition, { name: 'updateCategoryPosition' }),
  withStyles(styles),
  withSnackbar,
  withApollo
);

export default enhance(Categories);



// WEBPACK FOOTER //
// ./src/views/shop/components/Categories.jsx